/** @jsx jsx */
import { jsx } from "theme-ui"
import EventsCalendar from "../event-calendar"

const EventsCalendarPattern = ({ blade, ...restProps }) => {
  return <EventsCalendar sx={{ width: "100%" }} {...restProps} />
}

export default EventsCalendarPattern
